import { render, staticRenderFns } from "./CreateBasicModal.vue?vue&type=template&id=3a0652a8&scoped=true&"
import script from "./CreateBasicModal.vue?vue&type=script&lang=ts&"
export * from "./CreateBasicModal.vue?vue&type=script&lang=ts&"
import style0 from "./CreateBasicModal.vue?vue&type=style&index=0&id=3a0652a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0652a8",
  null
  
)

export default component.exports